export const COOKIE_BANNER_ID = 'cookie-banner-dialog';
export const COOKIE_CONSENT = 'cookie_consent';

// Cookie expiry (days)
export const OPTIONAL_COOKIES_EXPIRY = 365;
export const DECLINE_OPTIONAL_COOKIES_EXPIRY = 30;
export const MARKET_COOKIE_EXPIRY = 30;
export const REDIRECT_COOKIE_EXPIRY = 30;
